import {HStack, Text, Tooltip} from '@chakra-ui/react';
import {ItemCatalogue2FFData} from 'api-types/ffconnect';
import {useTranslation} from 'react-i18next';

interface ArticleCodesDisplayProps {
  code_article: string;
  marketplace_id?: string;
  toledeData?: Pick<
    NonNullable<ItemCatalogue2FFData['tolede']>,
    'code_article_client' | 'code_generique' | 'priorite_generique'
  >;
  size?: string;
}

export const ArticleCodesDisplay: React.FC<ArticleCodesDisplayProps> = ({
  code_article,
  marketplace_id,
  toledeData,
  size = 'xs',
}) => {
  const {t} = useTranslation();

  const code_article_client = toledeData?.code_article_client;
  const code_generique = toledeData?.code_generique;
  const priorite_generique = toledeData?.priorite_generique;

  // Fake data
  // const code_article_client = '1234567890';
  // const code_generique = '1234567890';
  // const priorite_generique = 1;

  const showClient = !!code_article_client;
  const showGenerique =
    !!code_generique && typeof priorite_generique === 'number';

  let tooltipLabel = '';
  if (showGenerique) {
    tooltipLabel += `${t('codes.code_generique')} ${code_generique}`;
  }
  if (showClient) {
    if (tooltipLabel) {
      tooltipLabel += '\n'; // Add newline if generique was added
    }
    tooltipLabel += `${t('codes.code_client')} ${code_article_client}`;
  }

  let combinedCodeText = '';
  if (showClient && showGenerique) {
    combinedCodeText = `(${code_article_client} / ${code_generique})`;
  } else if (showClient) {
    combinedCodeText = `(${code_article_client})`;
  } else if (showGenerique) {
    combinedCodeText = `(${code_generique})`;
  }

  return (
    <HStack
      alignContent='baseline'
      spacing={2}
    >
      {/* Code Article (France Frais) - Bold, no tooltip */}
      <Text
        fontSize={size}
        fontWeight='semibold'
        as='span'
        color='gray.dark'
      >
        {code_article}
      </Text>

      {/* Combined Code Client / Generique */}
      {(showClient || showGenerique) && (
        <Tooltip
          label={tooltipLabel}
          placement='top'
          hasArrow
          whiteSpace='pre-line'
        >
          <Text
            fontSize={size}
            fontWeight='400'
            color='gray.dark'
            as='span'
          >
            {combinedCodeText}
          </Text>
        </Tooltip>
      )}

      {marketplace_id && marketplace_id !== 'FF' && (
        <Text
          fontSize={size}
          fontWeight='400'
          color='blue.main'
          as='span'
        >
          {t(`marketplace.catalogue_${marketplace_id}`)}
        </Text>
      )}
    </HStack>
  );
};
